"use client";

import { useState, type ComponentPropsWithoutRef, type FormEvent } from "react";
import type { Localized } from "@/libs/localization/i18n";
import { useWorkspace } from "./workspace";

interface ValidatedFormProps extends Omit<
    ComponentPropsWithoutRef<"form">,
    "onSubmit"
> {
    onSubmit: (event: FormEvent<HTMLFormElement>) => Localized | void;
}

export const ValidatedForm = ({
    children,
    onSubmit,
    ...props
}: ValidatedFormProps) => {
    const { l } = useWorkspace();
    const [error, setError] = useState<Localized | undefined>();

    return (
        <>
            <form
                {...props}
                noValidate
                onSubmit={(event) => {
                    event.preventDefault();
                    setError(onSubmit(event) || undefined);
                }}
            >
                {children}
            </form>
            {error && (
                <p role="alert" className="mt-3 text-xs text-danger">
                    {l(error)}
                </p>
            )}
        </>
    );
};
